import React from 'react';
import { theme } from '@/styles/theme';
import { Edit, Delete, RestoreFromTrash } from '@mui/icons-material';
import { Stack, Tooltip, IconButton } from '@mui/material';
import { Can } from '@/components/common';

interface IRolesTableActionsProps {
  id: string;
  deletedAt?: string;
  // eslint-disable-next-line no-unused-vars
  onEditRole: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onDeleteRole: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onRestoreRole: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onEditRoleMouseEnter: (id: string) => void;
}

export function RolesTableActions({
  id,
  deletedAt,
  onEditRole,
  onDeleteRole,
  onRestoreRole,
  onEditRoleMouseEnter,
}: IRolesTableActionsProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      <Can permissions={['roles_update']}>
        <Tooltip title="Alterar" disableInteractive>
          <IconButton
            onMouseEnter={() => onEditRoleMouseEnter(id)}
            onClick={() => onEditRole(id)}
            size="small"
            sx={{
              '&:hover': {
                color: theme.palette.primary.main,
              },
            }}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Tooltip>
      </Can>
      {deletedAt ? (
        <Can permissions={['roles_restore']}>
          <Tooltip title="Restaurar" disableInteractive>
            <IconButton
              onClick={() => onRestoreRole(id)}
              size="small"
              sx={{
                '&:hover': {
                  color: theme.palette.primary.main,
                },
              }}
            >
              <RestoreFromTrash fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      ) : (
        <Can permissions={['roles_delete']}>
          <Tooltip title="Excluir" disableInteractive>
            <IconButton
              onClick={() => onDeleteRole(id)}
              size="small"
              sx={{
                '&:hover': {
                  color: theme.palette.error.main,
                },
              }}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </Can>
      )}
    </Stack>
  );
}
